import { Box, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

export default function VolunteeredHours() {
  const [hours, setHours] = useState(0);
  const { volunteered_minutes: volunteeredMinutes = 0 } = useSelector((state) => state.profile);

  useEffect(() => {
    let start = 0;
    const hrs = Math.floor(volunteeredMinutes / 60);
    if (start >= hrs) {
      if (hrs === 0) {
        setHours(0);
      }
      return;
    }
    const counter = setInterval(() => {
      start += 1;
      setHours(start);
      if (start >= hrs) {
        clearInterval(counter);
      }
    }, 10);
  }, [volunteeredMinutes]);

  const boxStyle = useMemo(
    () => ({
      padding: 3,
      backgroundColor: "green.main",
      boxShadow: "0px 4px 8px rgba(20, 38, 103, 0.04), 0px 0px 2px rgba(20, 38, 103, 0.06), 0px 0px 1px rgba(20, 38, 103, 0.04)",
      borderRadius: 1,
    }),
    []
  );

  const textStyle = useMemo(
    () => ({
      color: "background.paper",
      fontSize: 20,
      fontEeight: 700,
      lineHeight: "23px",
      textAlign: "center",
    }),
    []
  );

  const numberStyle = useMemo(
    () => ({
      color: "background.paper",
      fontSize: 55,
      fontEeight: 700,
      lineHeight: "64px",
      textAlign: "center",
    }),
    []
  );

  return (
    <Box sx={boxStyle}>
      <Typography sx={textStyle}>Total volunteer hours</Typography>
      <Typography sx={numberStyle}>{hours}</Typography>
    </Box>
  );
}
